import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import { HeadingM } from "./Typography";

export const CardPaper = styled(Paper, {
    shouldForwardProp: (prop) => prop !== "isDisabled",
})<{ isDisabled?: boolean }>(({ theme, isDisabled }) =>
    theme.unstable_sx({
        p: 4,
        width: "70vw",
        minWidth: "70vw",
        height: "100%",
        flexShrink: 0,
        ...(isDisabled && {
            opacity: 0.5,
            pointerEvents: "none",
        }),
    }),
);

export const CardHeading = styled(HeadingM)(({ theme }) =>
    theme.unstable_sx({
        mb: 0,
    }),
);

export const CardSkeleton = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        minWidth: "70vw",
        height: 115,
        borderRadius: 1,
        flexShrink: 0,
    }),
);
